import useAuth from '../features/authentication/hooks/useAuth';

const useIsLouiseQAPlan = () => {
  const { user } = useAuth();
  return user?.plan === 'LOUISE_QA';
};

export default useIsLouiseQAPlan;
